
import React from 'react';

// const ModalSincronizacao = ({ isOpen, onClose, onConfirm, message, startDate, endDate, onDateChange }) => {
//     if (!isOpen) {
//         return null;
//     }

//     return (
//         <div style={modalStyles.overlay}>
//             <div style={modalStyles.modal}>
//                 <div style={modalStyles.header}>
//                     <h3>Sincronização com o banco</h3>
//                 </div>
//                 <div style={modalStyles.body}>
//                     <p>{message}</p>
//                     <div style={modalStyles.dateInputs}>
//                         <label>
//                             Data Inicial:
//                             <input
//                                 type="date"
//                                 value={startDate}
//                                 onChange={(e) => onDateChange('startDate', e.target.value)}
//                                 style={modalStyles.inputField}
//                             />
//                         </label>
//                         <label>
//                             Data Final:
//                             <input
//                                 type="date"
//                                 value={endDate}
//                                 onChange={(e) => onDateChange('endDate', e.target.value)}
//                                 style={modalStyles.inputField}
//                             />
//                         </label>
//                     </div>
//                 </div>
//                 <div style={modalStyles.footer}>
//                     <button onClick={onClose} style={modalStyles.buttonCancel}>Cancelar</button>
//                     <button onClick={onConfirm} style={modalStyles.buttonConfirm}>Confirmar</button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// Exemplo de estilos simples para o modal

const ModalSincronizacao = ({ isOpen, onClose, onConfirm, message, startDate, endDate, onDateChange, isLoading }) => {
    // Se isOpen for false, o componente não renderiza nada
    if (!isOpen) {
        return null;
    }

    return (
        <div style={modalStyles.overlay}>
            <div style={modalStyles.modal}>
                <div style={modalStyles.header}>
                    <h3>Sincronização com o banco</h3>
                </div>
                <div style={modalStyles.body}>
                    {isLoading ? (
                        // Mostra o loading se isLoading for true
                        <p style={{ textAlign: 'center', fontWeight: 'bold' }}>Sincronizando, aguarde...</p>
                    ) : (
                        // Mostra o conteúdo normal
                        <>
                            <p>{message}</p>
                            <div style={modalStyles.dateInputs}>
                                <label>
                                    Data Inicial:
                                    <input
                                        type="date"
                                        value={startDate}
                                        onChange={(e) => onDateChange('startDate', e.target.value)}
                                        style={modalStyles.inputField}
                                    />
                                </label>
                                <label>
                                    Data Final:
                                    <input
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => onDateChange('endDate', e.target.value)}
                                        style={modalStyles.inputField}
                                    />
                                </label>
                            </div>
                        </>
                    )}
                </div>
                <div style={modalStyles.footer}>
                    <button onClick={onClose} style={modalStyles.buttonCancel} disabled={isLoading}>Cancelar</button>
                    <button onClick={onConfirm} style={modalStyles.buttonConfirm} disabled={isLoading}>
                        {isLoading ? 'Sincronizando...' : 'Confirmar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

const modalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
    },
    modal: {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        width: '400px',
        maxWidth: '90%',
        textAlign: 'center',
    },
    header: {
        marginBottom: '15px',
        borderBottom: '1px solid #ddd',
        paddingBottom: '10px'
    },
    body: {
        marginBottom: '20px'
    },
    dateInputs: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginTop: '15px',
        alignItems: 'center'
    },
    inputField: {
        padding: '8px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        width: '100%',
        boxSizing: 'border-box'
    },
    footer: {
        display: 'flex',
        justifyContent: 'space-around',
    },
    buttonConfirm: {
        padding: '10px 20px',
        borderRadius: '4px',
        border: 'none',
        backgroundColor: '#007bff',
        color: '#fff',
        cursor: 'pointer'
    },
    buttonCancel: {
        padding: '10px 20px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        backgroundColor: '#fff',
        cursor: 'pointer'
    }
};

export default ModalSincronizacao;